import { render, staticRenderFns } from "./MensagensNova.vue?vue&type=template&id=1323f111&scoped=true&lang=pug&"
import script from "./MensagensNova.vue?vue&type=script&lang=js&"
export * from "./MensagensNova.vue?vue&type=script&lang=js&"
import style0 from "./MensagensNova.vue?vue&type=style&index=0&id=1323f111&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323f111",
  null
  
)

export default component.exports